module.exports = __webpack_public_path__ + "img/7.1d12b04b.png";